var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { createContext, useEffect, useState } from 'react';
import { getDefaultMapTools } from '../../components/Maptools';
import { useAuth } from '@tenderd/track-web-utils';
import { DISTANT_VEHICLE_DISTANCE_IN_METERS } from '../../constants/Constants';
import { useDebounce } from 'use-debounce';
var GroupTrackingPageContext = createContext({
    filters: null,
    setFilters: null,
    debouncedFilters: null,
    selectedEquipment: null,
    setSelectedEquipment: null,
    selectedEquipmentFromMarker: null,
    setSelectedEquipmentFromMarker: null,
    machines: null,
    setMachines: null,
    loadingIfNotInList: false,
    setLoadingIfNotInList: null,
    equipment: null,
    setEquipment: null,
    deviceLocations: [],
    setDeviceLocations: null,
    loadingMap: false,
    setLoadingMap: null,
    mapTools: null,
    setMapTools: null,
    calculatedDistance: 0,
    setCalculatedDistance: null,
    setTelematicDevices: null,
    telematicDevicesCount: 0,
    setTelematicDevicesCount: null,
    telematicDevices: [],
    page: 1,
    setPage: null
});
export var useGroupTrackingPageContext = function () {
    return React.useContext(GroupTrackingPageContext);
};
var GroupTrackingPageContextProvider = function (props) {
    var account = useAuth().account;
    var _a = __read(useState(), 2), filters = _a[0], setFilters = _a[1];
    var _b = __read(useDebounce(filters, 1000), 1), debouncedFilters = _b[0];
    var _c = __read(useState(), 2), selectedEquipment = _c[0], setSelectedEquipment = _c[1];
    var _d = __read(useState(), 2), selectedEquipmentFromMarker = _d[0], setSelectedEquipmentFromMarker = _d[1];
    var _e = __read(useState(), 2), machines = _e[0], setMachines = _e[1];
    var _f = __read(useState(false), 2), loadingIfNotInList = _f[0], setLoadingIfNotInList = _f[1];
    var _g = __read(useState(), 2), equipment = _g[0], setEquipment = _g[1];
    var _h = __read(useState([]), 2), deviceLocations = _h[0], setDeviceLocations = _h[1];
    var _j = __read(useState([]), 2), telematicDevices = _j[0], setTelematicDevices = _j[1];
    var _k = __read(useState(0), 2), telematicDevicesCount = _k[0], setTelematicDevicesCount = _k[1];
    var _l = __read(useState(true), 2), loadingMap = _l[0], setLoadingMap = _l[1];
    var _m = __read(useState(0), 2), calculatedDistance = _m[0], setCalculatedDistance = _m[1];
    var _o = __read(useState(getDefaultMapTools(account.id)), 2), mapTools = _o[0], setMapTools = _o[1];
    var _p = __read(useState(false), 2), hasEffectRun = _p[0], setHasEffectRun = _p[1];
    var _q = __read(useState(1), 2), page = _q[0], setPage = _q[1];
    useEffect(function () {
        if (deviceLocations && deviceLocations.length > 300 && !hasEffectRun) {
            setMapTools(function (prev) { return (__assign(__assign({}, prev), { showLabels: false, showModelNames: false, showCustomIDs: false, showCluster: true })); });
            setHasEffectRun(true);
        }
    }, [deviceLocations, hasEffectRun]);
    useEffect(function () {
        if (mapTools === null || mapTools === void 0 ? void 0 : mapTools.hideDistantVehicles) {
            console.log("Radius: enabled");
            setFilters(function (prev) { return (__assign(__assign({}, prev), { radius: DISTANT_VEHICLE_DISTANCE_IN_METERS })); });
        }
        else {
            console.log("Radius: disabled");
            setFilters(function (prev) { return (__assign(__assign({}, prev), { radius: undefined })); });
        }
    }, [mapTools === null || mapTools === void 0 ? void 0 : mapTools.hideDistantVehicles]);
    return (React.createElement(GroupTrackingPageContext.Provider, { value: {
            filters: filters,
            setFilters: setFilters,
            debouncedFilters: debouncedFilters,
            selectedEquipment: selectedEquipment,
            setSelectedEquipment: setSelectedEquipment,
            selectedEquipmentFromMarker: selectedEquipmentFromMarker,
            setSelectedEquipmentFromMarker: setSelectedEquipmentFromMarker,
            machines: machines,
            setMachines: setMachines,
            loadingIfNotInList: loadingIfNotInList,
            setLoadingIfNotInList: setLoadingIfNotInList,
            equipment: equipment,
            setEquipment: setEquipment,
            deviceLocations: deviceLocations,
            setDeviceLocations: setDeviceLocations,
            loadingMap: loadingMap,
            mapTools: mapTools,
            setMapTools: setMapTools,
            setLoadingMap: setLoadingMap,
            calculatedDistance: calculatedDistance,
            setCalculatedDistance: setCalculatedDistance,
            telematicDevices: telematicDevices,
            setTelematicDevices: setTelematicDevices,
            telematicDevicesCount: telematicDevicesCount,
            setTelematicDevicesCount: setTelematicDevicesCount,
            hasEffectRun: hasEffectRun,
            page: page,
            setPage: setPage
        } }, props.children));
};
export default GroupTrackingPageContextProvider;
